import axios from 'services/axios';
import { API } from 'services/constants';

const createAction = name => ({
  GET_COMPANY_PENDING: `${name}_GET_COMPANY_PENDING`,
  GET_COMPANY_SUCCESS: `${name}_GET_COMPANY_SUCCESS`,
  GET_COMPANY_FALIED: `${name}_GET_COMPANY_FALIED`,
  SET_COMPANY_SELECT: `${name}_SET_COMPANY_SELECT`
});

export const COMPANY = createAction('COMPANY');

export const GetCompany = () => async dispatch => {
  dispatch({ type: COMPANY.GET_COMPANY_PENDING });
  try {
    const response = await axios
      .get(API.GET_COMPANY, { headers: { 'Content-Type': 'application/json' } })
      .then(res => res.data)
      .catch(error => Promise.reject(error));

    dispatch({
      type: COMPANY.GET_COMPANY_SUCCESS,
      payload: response
    });
  } catch (error) {
    dispatch({
      type: COMPANY.GET_COMPANY_FALIED,
      error
    });
  }
};

export const SetCompanySelect = select => dispatch => {
  dispatch({
    type: COMPANY.SET_COMPANY_SELECT,
    payload: select
  });
};
